import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { PlacementArray } from "@ng-bootstrap/ng-bootstrap/util/positioning";
import {
  IonicPage,
  LoadingController,
  NavController,
  NavParams,
  ToastController,
  ViewController,
} from "ionic-angular";
import * as _ from "lodash";
import moment from "moment";
import { commonVar } from "../../../providers/common-var/common";
import { ReferralsServiceProvider } from "../../../providers/patient-charts/referrals-service";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import {
  CertificationPeriod,
  CertificationService,
} from "../../services/certification-service";
import { AuthService } from "./../../../app/auth/auth.service";

@IonicPage()
@Component({
  selector: "page-certification-received",
  templateUrl: "certification-received.html",
})
export class CertificationReceivedModal {
  certificationForm: FormGroup;
  maxDate = new Date();
  maxDateFormat = {
    year: this.maxDate.getFullYear(),
    month: this.maxDate.getMonth() + 1,
    day: this.maxDate.getDate(),
  };
  minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 100));
  minDateFormat = {
    year: this.minDate.getFullYear(),
    month: this.minDate.getMonth() + 1,
    day: this.minDate.getDate(),
  };

  sameAsError: string = "";
  payers: any;

  data: any = {
    certifyingPhysician: {
      address: null,
    },
  };
  patientId: any;

  spinner: any = null;
  spinnerCounter: number = 0;

  datePlacementPreference: PlacementArray = ["bottom-left"];

  public certTypeControl: FormControl;
  private physicianData = {};

  public certificationPeriodFrom;
  public certificationPeriodTo;

  public showReceiverOptions = false;
  public receiverOptions: any[] = [];
  protected hasValidUsername = false;

  public showCertifyingOptions = false;
  public certifyingOptions: any[] = [];

  public showAttendingOptions = false;
  public attendingOptions: any[] = [];

  public physicians: any[] = [];
  public showPhysicianOptions = false;
  public physicianOptions: any[] = [];
  public disabledBtn = false;
  public verbalDisabled = false;
  public writtenDisabled = false;

  constructor(
    public referralsService: ReferralsServiceProvider, // TODO: Replace with new cert service phys lookup
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    private certificationSvc: CertificationService,
    public stateData: StateManagementService,
    private authSvc: AuthService
  ) {
    this.patientId = this.stateData.getChartId();

    let nav_data = navParams.data;

    this.certTypeControl = new FormControl("");

    this.certificationForm = new FormGroup({
      id: new FormControl(""),
      certificationPeriodFrom: new FormControl("", Validators.required),
      certificationPeriodTo: new FormControl("", Validators.required),

      receiverName: new FormControl(
        "",
        Validators.compose([Validators.required, Validators.maxLength(150)])
      ),
      receivedDate: new FormControl("", Validators.required),
      certifyingPhysicianId: new FormControl(""),
      certifyingName: new FormControl("", Validators.required),
      certifyingReceivedDate: new FormControl("", Validators.required),

      attendingPhysicianId: new FormControl(""),
      attendingName: new FormControl(""),
      attendingReceivedDate: new FormControl(""),

      obtainedFrom: new FormControl("", Validators.required),
      obtainedDate: new FormControl("", Validators.required),
    });

    this.certTypeControl.valueChanges.subscribe((val) => {
      switch (val) {
        case "VERBAL":
          this.certificationForm
            .get("receiverName")
            .enable({ emitEvent: false });
          this.certificationForm
            .get("receivedDate")
            .enable({ emitEvent: false });
          this.certificationForm
            .get("certifyingName")
            .disable({ emitEvent: false });
          this.certificationForm
            .get("certifyingReceivedDate")
            .disable({ emitEvent: false });
          this.certificationForm
            .get("attendingName")
            .disable({ emitEvent: false });
          this.certificationForm
            .get("attendingReceivedDate")
            .disable({ emitEvent: false });
          this.certificationForm
            .get("obtainedFrom")
            .enable({ emitEvent: false });
          this.certificationForm
            .get("obtainedDate")
            .enable({ emitEvent: false });
          break;
        case "WRITTEN":
          this.certificationForm
            .get("receiverName")
            .disable({ emitEvent: false });
          this.certificationForm
            .get("receivedDate")
            .disable({ emitEvent: false });
          this.certificationForm
            .get("certifyingName")
            .enable({ emitEvent: false });
          this.certificationForm
            .get("certifyingReceivedDate")
            .enable({ emitEvent: false });
          this.certificationForm
            .get("attendingName")
            .enable({ emitEvent: false });
          this.certificationForm
            .get("attendingReceivedDate")
            .enable({ emitEvent: false });
          this.certificationForm
            .get("obtainedFrom")
            .disable({ emitEvent: false });
          this.certificationForm
            .get("obtainedDate")
            .disable({ emitEvent: false });
          break;
        default:
      }
    });

    this.certificationForm.get("receiverName").valueChanges.subscribe((val) => {
      //console.log(val);
      this.hasValidUsername = val === this.currentUserFullName;
    });

    // Edit case
    if (!nav_data.addNewData && !_.isEmpty(nav_data.certificateData)) {
      this.data = nav_data.certificateData;
      if (this.data) {
        this.certificationForm.get("id").setValue(this.data.id);
        if (
          this.data.type == "WRITTEN_PATIENT_CHART" ||
          this.data.type == "WRITTEN_IDG"
        ) {
          this.verbalDisabled = true;
          this.certTypeControl.setValue("WRITTEN");
          this.certificationForm
            .get("certifyingPhysicianId")
            .setValue(this.data.certifyingPhysicianId);
          this.certificationForm
            .get("certifyingName")
            .setValue(this.data.certifyingPhysician);
          this.certificationForm
            .get("attendingName")
            .setValue(this.data.attendingPhysician);
          this.certificationForm
            .get("attendingPhysicianId")
            .setValue(this.data.attendingPhysicianId);
          this.certificationForm
            .get("certifyingReceivedDate")
            .setValue(
              moment(this.data.certifyingPhysicianSignedDate).format(
                "MM/DD/YYYY"
              )
            );
          this.certificationForm
            .get("attendingReceivedDate")
            .setValue(
              moment(this.data.attendingPhysicianSignedDate).format(
                "MM/DD/YYYY"
              )
            );
        } else {
          this.writtenDisabled = true;
          this.certTypeControl.setValue("VERBAL");
          this.certificationForm
            .get("receiverName")
            .setValue(this.data.receivedBy, { emitEvent: true });
          this.certificationForm
            .get("obtainedFrom")
            .setValue(this.data.certifyingPhysician);
          this.certificationForm
            .get("receivedDate")
            .setValue(moment(this.data.receivedByDate).format("MM/DD/YYYY"));
          this.certificationForm
            .get("obtainedDate")
            .setValue(
              moment(this.data.certifyingPhysicianSignedDate).format(
                "MM/DD/YYYY"
              )
            );
        }
      }
    }

    this.certificationForm.get("receiverName").valueChanges.subscribe((val) => {
      //console.log(val);
      this.hasValidUsername = val === this.currentUserFullName;
    });

    this.certificationForm
      .get("certifyingName")
      .valueChanges.subscribe((val) => {
        this.searchPhysician(val, "certifyingName");
      });

    this.certificationForm
      .get("attendingName")
      .valueChanges.subscribe((val) => {
        this.searchPhysician(val, "attendingName");
      });

    this.certificationForm.get("obtainedFrom").valueChanges.subscribe((val) => {
      this.searchPhysician(val, "obtainedFrom");
    });
  }

  ngOnInit(): void {
    this.certificationSvc.getCertificationPeriod(this.patientId).subscribe(
      (period) => this.updateCertificationPeriod(period),
      (err) => {
        this.toastCtrl.create({
          message: "Unable to load certification period.",
          duration: 4000,
          position: "below",
          cssClass: "error",
        });
      }
    );

    this.certificationSvc.getPhysicianData().subscribe(
      (response: string[]) => {
        this.physicians = response;
      },
      (err) => {}
    );
  }

  protected get currentUserFullName() {
    return this.authSvc.getUser().name;
  }

  private updateCertificationPeriod(period: CertificationPeriod) {
    this.certificationPeriodFrom = moment(period.certificationFromDate).format(
      "MM/DD/YYYY"
    );
    this.certificationPeriodTo = moment(period.certificationToDate).format(
      "MM/DD/YYYY"
    );

    this.certificationForm
      .get("certificationPeriodFrom")
      .setValue(moment(period.certificationFromDate).format("MM/DD/YYYY"));
    this.certificationForm
      .get("certificationPeriodTo")
      .setValue(moment(period.certificationToDate).format("MM/DD/YYYY"));
  }

  searchPhysician(searchTerm: string, fieldName: string) {
    let options = [];
    let showFlag = false;
    if (searchTerm && searchTerm.length > 2 && this.physicians) {
      showFlag = true;
      options = this.physicians
        .map((physician) => {
          return {
            name: (
              physician.firstName +
              " " +
              physician.lastName
            ).toLowerCase(),
            firstName: physician.firstName,
            lastName: physician.lastName,
            id: physician.qbosId,
          };
        })
        .filter((data) => {
          return (
            data.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
          );
        });
      this.setPhysicianOptions(
        _.sortBy(options, "lastName"),
        showFlag,
        fieldName
      );
    } else {
      this.setPhysicianOptions(options, showFlag, fieldName);
    }
  }

  setPhysicianOptions(options: string[], showFlag: boolean, fieldName: string) {
    switch (fieldName) {
      case "certifyingName":
        this.certifyingOptions = options;
        this.showCertifyingOptions = showFlag;
        break;
      case "attendingName":
        this.attendingOptions = options;
        this.showAttendingOptions = showFlag;
        break;
      case "obtainedFrom":
        this.physicianOptions = options;
        this.showPhysicianOptions = showFlag;
        break;
      default:
    }
  }

  setPhysician(phys, control: string) {
    const physControl = this.certificationForm.get(control);
    if (physControl) {
      physControl.setValue(`${phys.firstName} ${phys.lastName}`);
      if (control == "attendingName") {
        this.certificationForm
          .get("attendingPhysicianId")
          .setValue(`${phys.id}`);
      } else if (control == "certifyingName") {
        this.certificationForm
          .get("certifyingPhysicianId")
          .setValue(`${phys.id}`);
      }
      this.physicianData[control] = phys;
      this.showCertifyingOptions = false;
      this.showPhysicianOptions = false;
      this.showAttendingOptions = false;
    }
  }

  // cancel popup.
  onDismiss() {
    this.viewCtrl.dismiss({ cancel: true });
    this.disabledBtn = false;
  }

  onSubmit(data?: any) {
    this.disabledBtn = true;
    if (data.id) {
      if (this.certTypeControl.value === "WRITTEN") {
        if (this.data.type == "WRITTEN_PATIENT_CHART") {
          const payload = {
            id: data.id,
            certifyingPhysicianName:
              this.certificationForm.get("certifyingName").value,
            attendingPhysicianName:
              this.certificationForm.get("attendingName").value,
            certifyingPhysicianSignedDate: moment(
              new Date(
                this.certificationForm.get("certifyingReceivedDate").value
              )
            )
              .hour(new Date().getHours())
              .minute(new Date().getMinutes())
              .second(new Date().getSeconds())
              .toISOString(),
            attendingPhysicianSignedDate: this.certificationForm.get(
              "attendingReceivedDate"
            ).value
              ? moment(
                  new Date(
                    this.certificationForm.get("attendingReceivedDate").value
                  )
                )
                  .hour(new Date().getHours())
                  .minute(new Date().getMinutes())
                  .second(new Date().getSeconds())
                  .toISOString()
              : null,
            periodEndDateTime: moment
              .utc(this.certificationForm.get("certificationPeriodTo").value)
              .hour(0)
              .minute(0)
              .second(0)
              .toISOString(),
            periodStartDateTime: moment
              .utc(this.certificationForm.get("certificationPeriodFrom").value)
              .hour(0)
              .minute(0)
              .second(0)
              .toISOString(),
            attendingPhysicianId: this.certificationForm.get(
              "attendingPhysicianId"
            ).value,
            certifyingPhysicianId: this.certificationForm.get(
              "certifyingPhysicianId"
            ).value,
          };

          this.certificationSvc
            .PatientChart_UpdateWrittenCti(payload)
            .subscribe(
              (response) => {
                if (response) {
                  this.referralsService.CERTIFICATE_ICON =
                    commonVar.COMPLETED_ICON;
                  this.viewCtrl.dismiss({
                    updated: true,
                    cancel: false,
                  });
                }
                this.disabledBtn = false;
              },
              (err) => {
                this.presentToast(err.message);
                this.disabledBtn = false;
              }
            );
        } else {
          const payload = {
            id: data.id,
            physicianSignature:
              this.certificationForm.get("certifyingName").value,
            certificationDateTime: moment(
              new Date(
                this.certificationForm.get("certifyingReceivedDate").value
              )
            )
              .hour(new Date().getHours())
              .minute(new Date().getMinutes())
              .second(new Date().getSeconds())
              .toISOString(),
            periodEndDateTime: moment
              .utc(this.certificationForm.get("certificationPeriodTo").value)
              .hour(0)
              .minute(0)
              .second(0)
              .toISOString(),
            periodStartDateTime: moment
              .utc(this.certificationForm.get("certificationPeriodFrom").value)
              .hour(0)
              .minute(0)
              .second(0)
              .toISOString(),
            attendingPhysicianName:
              this.certificationForm.get("attendingName").value,
            attendingPhysicianSignedDate: this.certificationForm.get(
              "attendingReceivedDate"
            ).value
              ? moment(
                  new Date(
                    this.certificationForm.get("attendingReceivedDate").value
                  )
                )
                  .hour(new Date().getHours())
                  .minute(new Date().getMinutes())
                  .second(new Date().getSeconds())
                  .toISOString()
              : null,
            attendingPhysicianId: this.certificationForm.get(
              "attendingPhysicianId"
            ).value,
            certifyingPhysicianId: this.certificationForm.get(
              "certifyingPhysicianId"
            ).value,
          };

          this.certificationSvc.IDG_UpdateWrittenCti(payload).subscribe(
            (response) => {
              if (response) {
                this.referralsService.CERTIFICATE_ICON =
                  commonVar.COMPLETED_ICON;
                this.viewCtrl.dismiss({
                  updated: true,
                  cancel: false,
                });
              }
              this.disabledBtn = false;
            },
            (err) => {
              this.presentToast(err.message);
              this.disabledBtn = false;
            }
          );
        }
      } else if (this.certTypeControl.value === "VERBAL") {
        if (this.data.type == "VERBAL_PATIENT_CHART") {
          const payload = {
            id: data.id,
            receiversName: this.certificationForm.get("receiverName").value,
            receiversSignedDate: moment(
              new Date(this.certificationForm.get("receivedDate").value)
            )
              .hour(new Date().getHours())
              .minute(new Date().getMinutes())
              .second(new Date().getSeconds())
              .toISOString(),
            periodEndDateTime: moment
              .utc(this.certificationForm.get("certificationPeriodTo").value)
              .hour(0)
              .minute(0)
              .second(0)
              .toISOString(),
            periodStartDateTime: moment
              .utc(this.certificationForm.get("certificationPeriodFrom").value)
              .hour(0)
              .minute(0)
              .second(0)
              .toISOString(),
            obtainedFromName: this.certificationForm.get("obtainedFrom").value,
            obtainedSignedDate: moment(
              new Date(this.certificationForm.get("obtainedDate").value)
            )
              .hour(new Date().getHours())
              .minute(new Date().getMinutes())
              .second(new Date().getSeconds())
              .toISOString(),
          };
          this.certificationSvc.PatientChart_UpdateVerbalCti(payload).subscribe(
            (response) => {
              if (response) {
                this.referralsService.CERTIFICATE_ICON =
                  commonVar.COMPLETED_ICON;
                this.viewCtrl.dismiss({
                  updated: true,
                  cancel: false,
                });
              }
            },
            (err) => {
              this.presentToast(err.message);
              this.disabledBtn = false;
            }
          );
        } else {
          const payload = {
            id: data.id,
            staffSignature: this.certificationForm.get("receiverName").value,
            staffSignedDate: moment(
              new Date(this.certificationForm.get("receivedDate").value)
            )
              .hour(new Date().getHours())
              .minute(new Date().getMinutes())
              .second(new Date().getSeconds())
              .toISOString(),
            periodEndDateTime: moment
              .utc(this.certificationForm.get("certificationPeriodTo").value)
              .hour(0)
              .minute(0)
              .second(0)
              .toISOString(),
            periodStartDateTime: moment
              .utc(this.certificationForm.get("certificationPeriodFrom").value)
              .hour(0)
              .minute(0)
              .second(0)
              .toISOString(),
            obtainedFromName: this.certificationForm.get("obtainedFrom").value,
            obtainedSignedDate: moment(
              new Date(this.certificationForm.get("obtainedDate").value)
            )
              .hour(new Date().getHours())
              .minute(new Date().getMinutes())
              .second(new Date().getSeconds())
              .toISOString(),
          };

          this.certificationSvc.Referral_UpdateVerbalCti(payload).subscribe(
            (response) => {
              if (response) {
                this.referralsService.CERTIFICATE_ICON =
                  commonVar.COMPLETED_ICON;
                this.viewCtrl.dismiss({
                  updated: true,
                  cancel: false,
                });
              }
            },
            (err) => {
              this.presentToast(err.message);
              this.disabledBtn = false;
            }
          );
        }
      }
    } else {
      if (this.certTypeControl.value === "WRITTEN") {
        const payload = {
          origin: "PATIENT_CHART",
          type: "WRITTEN_PATIENT_CHART",
          patientQbosId: parseInt(this.patientId),
          certifyingPhysicianName:
            this.certificationForm.get("certifyingName").value,
          attendingPhysicianName:
            this.certificationForm.get("attendingName").value,
          certifyingPhysicianSignedDate: moment(
            new Date(this.certificationForm.get("certifyingReceivedDate").value)
          )
            .hour(new Date().getHours())
            .minute(new Date().getMinutes())
            .second(new Date().getSeconds())
            .toISOString(),
          attendingPhysicianSignedDate: this.certificationForm.get(
            "attendingReceivedDate"
          ).value
            ? moment(
                new Date(
                  this.certificationForm.get("attendingReceivedDate").value
                )
              )
                .hour(new Date().getHours())
                .minute(new Date().getMinutes())
                .second(new Date().getSeconds())
                .toISOString()
            : null,
          periodEndDateTime: moment
            .utc(this.certificationForm.get("certificationPeriodTo").value)
            .hour(0)
            .minute(0)
            .second(0)
            .toISOString(),
          periodStartDateTime: moment
            .utc(this.certificationForm.get("certificationPeriodFrom").value)
            .hour(0)
            .minute(0)
            .second(0)
            .toISOString(),
          attendingPhysicianId: this.certificationForm.get(
            "attendingPhysicianId"
          ).value,
          certifyingPhysicianId: this.certificationForm.get(
            "certifyingPhysicianId"
          ).value,
        };

        this.certificationSvc.PatientChart_createWrittenCti(payload).subscribe(
          (response) => {
            if (response) {
              this.referralsService.CERTIFICATE_ICON = commonVar.COMPLETED_ICON;
              this.viewCtrl.dismiss({
                created: true,
                cancel: false,
              });
            }
            this.disabledBtn = false;
          },
          (err) => {
            this.presentToast(err.message);
            this.disabledBtn = false;
          }
        );
      } else if (this.certTypeControl.value === "VERBAL") {
        const payload = {
          origin: "PATIENT_CHART",
          type: "VERBAL_PATIENT_CHART",
          patientQbosId: parseInt(this.patientId),
          receiversName: this.certificationForm.get("receiverName").value,
          receiversSignedDate: moment(
            new Date(this.certificationForm.get("receivedDate").value)
          )
            .hour(new Date().getHours())
            .minute(new Date().getMinutes())
            .second(new Date().getSeconds())
            .toISOString(),
          periodEndDateTime: moment
            .utc(this.certificationForm.get("certificationPeriodTo").value)
            .hour(0)
            .minute(0)
            .second(0)
            .toISOString(),
          periodStartDateTime: moment
            .utc(this.certificationForm.get("certificationPeriodFrom").value)
            .hour(0)
            .minute(0)
            .second(0)
            .toISOString(),
          obtainedFromName: this.certificationForm.get("obtainedFrom").value,
          obtainedSignedDate: moment(
            new Date(this.certificationForm.get("obtainedDate").value)
          )
            .hour(new Date().getHours())
            .minute(new Date().getMinutes())
            .second(new Date().getSeconds())
            .toISOString(),
        };

        this.certificationSvc.PatientChart_createVerbalCti(payload).subscribe(
          (response) => {
            if (response) {
              this.referralsService.CERTIFICATE_ICON = commonVar.COMPLETED_ICON;
              this.viewCtrl.dismiss({
                created: true,
                cancel: false,
              });
            }
          },
          (err) => {
            this.presentToast(err.message);
            this.disabledBtn = false;
          }
        );
      }
    }
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "below",
      cssClass: "error",
    });

    toast.onDidDismiss(() => {});

    toast.present();
  }

  // incremental loader function
  increaseSpinnerCount(message: string = "Creating Assessment...") {
    this.spinnerCounter++;
    if (this.spinnerCounter && this.spinner == null) {
      this.spinner = this.loadingCtrl.create({
        content: message,
      });
      this.spinner.present();
    }
  }

  // decremental loader function
  decreaseSpinnerCount() {
    this.spinnerCounter--;
    if (this.spinnerCounter <= 0) {
      this.spinner.dismiss();
      this.spinner = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/certification/forms/certification-received/certification-received.ts